<template>
  <div>
    <van-list @click="goDetails(item)" v-for="item in state.list" :key="item.id">
      <van-cell :title="item.title">
        <p>
          <span>{{ item.deptName }}</span>
          <span>{{ item.createName }}</span>
        </p>
      </van-cell>
    </van-list>
  </div>
</template>
<script setup>
  import { propagateList } from '@/api/propagate/propagate';
  import { reactive } from "vue";
  import { useRoute } from 'vue-router';
  const route = useRoute();
  const id = route.params.id;
  const state = reactive({
    list: []
  });
  const queryList = () => {
    propagateList({ id }).then(v => {
      const { data } = v;
      state.list = data.list;
    })
  }
  queryList();

  const goDetails = (item) => {
    console.log(item.url);
    window.location.href = item.url;
  }
</script>
<style lang="scss" scoped>
  .van-cell {
    display: inline-block;
    p {
      text-align: left;
      span:last-of-type {
        margin-left: 5%;
      }
    }
  }
</style>